module.exports = __webpack_public_path__ + "img/product-chuti-qt-10.df8f65fe.png";